import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LuCkeditorComponent } from './lu-ckeditor.component';
import { LuCkeditorRootConfig } from './lu-ckeditor.models';

const declarations = [LuCkeditorComponent];

const imports = [CommonModule];

@NgModule({
	declarations,
	imports,
	exports: [...declarations]
})
export class LuCkeditorModule {
	static forRoot(luCkConfig: LuCkeditorRootConfig): ModuleWithProviders<LuCkeditorModule> {
		return {
			ngModule: LuCkeditorModule,
			providers: [luCkConfig.dynamicScriptLoader]
		};
	}
}
